import { CertificateDesignerStore, CertificateTemplate } from "./certificateTypes";
import {
  cloneCertificateTemplate,
  DEFAULT_CERTIFICATE_TEMPLATES,
  DEFAULT_TEMPLATE_ID,
} from "./certificateTemplates";

const STORAGE_KEY = "our_dental.certificatePrint.templates.v1";

function builtinStore(): CertificateDesignerStore {
  return {
    templates: DEFAULT_CERTIFICATE_TEMPLATES.map((template) =>
      cloneCertificateTemplate(template, { id: template.id, name: template.name })
    ),
    activeId: DEFAULT_TEMPLATE_ID,
    defaultId: DEFAULT_TEMPLATE_ID,
  };
}

function hydrateTemplate(raw: CertificateTemplate): CertificateTemplate {
  const fallback = DEFAULT_CERTIFICATE_TEMPLATES[0];
  return {
    id: raw.id || `tpl-${Date.now()}`,
    name: raw.name || fallback.name,
    page: { ...fallback.page, ...raw.page },
    elements: Array.isArray(raw.elements) && raw.elements.length > 0 ? raw.elements : fallback.elements.map((el) => ({ ...el })),
  };
}

export function loadCertificateStore(): CertificateDesignerStore {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return builtinStore();
    const parsed = JSON.parse(raw) as CertificateDesignerStore;
    if (!parsed?.templates?.length) return builtinStore();
    const templates = parsed.templates.map(hydrateTemplate);
    const activeId = templates.some((item) => item.id === parsed.activeId)
      ? parsed.activeId
      : templates[0].id;
    const defaultId = templates.some((item) => item.id === parsed.defaultId)
      ? parsed.defaultId
      : templates[0].id;
    return { templates, activeId, defaultId };
  } catch {
    return builtinStore();
  }
}

export function saveCertificateStore(store: CertificateDesignerStore) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota / private mode */
  }
}

export function createTemplateId() {
  return `tpl-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}

export function findTemplate(
  templates: CertificateTemplate[],
  id: string
): CertificateTemplate {
  return templates.find((item) => item.id === id) ?? templates[0];
}

export function getPrintableCertificateTemplate(templateId?: string): CertificateTemplate {
  const store = loadCertificateStore();
  return findTemplate(store.templates, templateId || store.defaultId || store.activeId);
}
